import { render, staticRenderFns } from "./examStatistics.vue?vue&type=template&id=f9ddb1fe&scoped=true"
import script from "./examStatistics.vue?vue&type=script&lang=js"
export * from "./examStatistics.vue?vue&type=script&lang=js"
import style0 from "./examStatistics.vue?vue&type=style&index=0&id=f9ddb1fe&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ddb1fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Workplace\\vueProject\\edu_aim\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9ddb1fe')) {
      api.createRecord('f9ddb1fe', component.options)
    } else {
      api.reload('f9ddb1fe', component.options)
    }
    module.hot.accept("./examStatistics.vue?vue&type=template&id=f9ddb1fe&scoped=true", function () {
      api.rerender('f9ddb1fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/exam/examStatistics.vue"
export default component.exports